module.exports = __webpack_public_path__ + "static/MockedIn-209e43f08b488d3ab00d87abd7a56375.png";